import MarketCustomReportingIndexRoute from 'lumen/routes/market/custom-reporting/index';

export default class DestinationReportingIndexRoute extends MarketCustomReportingIndexRoute {}
